import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const UserList = React.lazy(() => import('components/User/List/List'));

function ScreensUsersList() {
  return (
    <BaseLayout>
      <DocumentTitle>Users List</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <UserList />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensUsersList;
